<template>
    <div name="steps" class="steps">
        <!-- <img class="logo" src="../../assets/barocare_logo.png" /> -->
        <div class="row-box" style="margin-top: 36px;">
            <!-- <div class="round-active" v-if="step === 1">1</div>
            <div class="round-active round-inactive" v-else>1</div>
            <div class="round-active" v-if="step === 2">2</div>
            <div class="round-active round-inactive" v-else>2</div>
            <div class="round-active" v-if="step === 3">3</div>
            <div class="round-active round-inactive" v-else>3</div> -->
            <img style="height: 66px;"  v-if="step === 1" src="../../assets/step1.png" />
            <img style="height: 66px;"  v-if="step === 2" src="../../assets/step2.png" />
            <img style="height: 66px;"  v-if="step === 3" src="../../assets/step3.png" />

        </div>
        <div class="column-box" style="margin-top: 30px;" v-if="step===1">
            <span class="title">환자 정보를 입력해 주세요</span>
            <span class="description">간편한 비대면진료를 위한 한 번의 환자 등록!<br/> <span class="description-strong">진료 받으실 분의 정보</span>를 등록해 주세요</span>
        </div>
        <div class="column-box" style="margin-top: 30px;" v-if="step===2">
            <span class="title">결제 카드를 등록해 주세요</span>
            <span class="description"><span class="description-strong">진료비/조제비 결제</span>를 위한 한 번의 카드 등록!</span>
            <!-- <span class="description" style="margin-top: 8px;"><span class="description-strong" style="color:#008DEF">하나카드</span>는 현재 지원하지 않습니다. 다른 카드사를<br/> 이용해 주세요.</span> -->
        </div>
        <div class="column-box" style="margin-top: 30px;" v-if="step===3">
            <span class="title">환자 등록이 완료되었습니다</span>
            <span class="description"><span class="description-strong">채팅으로</span> 간편하게 비대면진료를 예약해 보세요.</span>
        </div>
    </div>
</template>

<script>
// step 표현 
export default {
    name: 'steps',
    props: ['step']
}
</script>

<style scoped>
    .steps {
        width: calc(100% - 32px);
        background: var(--Gray-20, #F3F5F8);
        padding: 30px 16px 40px 16px;
    }
    .column-box {
        display: flex;
        flex-direction: column;
    }

    .row-box {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-content: center;
    }

    .description {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
        margin-top: 16px;
    }
    .description-strong {
        color: var(--Gray-100, #1E1E1E);
        font-weight: 600;
    }
    .title {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 26px; /* 108.333% */
    }
    .logo {
        width: 69px;
        height: 17px;
        flex-shrink: 0;
    }
    .round-active {
        width: 28px;
        height: 28px;
        flex-shrink: 0;
        background: #184FA1;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: var(--Gray-00, #FFF);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
        margin-right: 8px;
    }
    .round-inactive
    {
        color: var(--Gray-60, #6B7684);
        background: #E8EAEE;
    }
</style>


// WEBPACK FOOTER //
// src/components/molecules/Steps.vue